import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';

import { mdiClose } from '@mdi/js';
import Icon from '@mdi/react';
import { removeEmptyValueObject } from '../../utils/helpers';
import useQuery from '../../utils/hook/useQuery';
import List from './listHelpical';
import { useParams } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getTicketsAction, getTicketsCountAction, } from '../orders/actions';
import {
  makeSelectTicketList, makeSelectLoading,
  makeSelectError,
  makeSelectTicketCountList,
  makeSelectTicketsList,
} from '../orders/selectors';
import {
  Props,
  SelectorProps,
  Payload,

} from '../orders/interfaces';
import { Store } from '../../redux/reducers';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import handleError from '../../utils/handleError';





const useStyles = makeStyles(theme =>
  createStyles({
    loading: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    mobile: {
      maxWidth: '120%',
      margin: '16px 0',
      '@media (max-width: 480px)': {
        marginTop: '140px',
      },
    },
    card: {
      width: '100%',
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px 0 0',
      paddingBottom: '0',
    },
    cards: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
    },
    boxshadow: {
      position: 'relative',
      backgroundColor: 'white',
      padding: '14px',
      transform: 'translateY(-3px)',
      boxShadow: '-6px 6px 14px 0px rgba(0,0,0,0.15) !important',
    },
    iconHeader: {
      position: 'absolute',
      top: '5px',
      right: '5px',
    },
    cardContent: {
      marginTop: '-22px',
      display: 'flex',
      textAlign: 'center',
      justifyContent: 'center',
    },
    cardContentlist: {
      justifyContent: 'space-between',
      padding: ' 0',
    },
  })
);

const HelpdeskParcel = props => {
  const params = useParams();

  const classes = useStyles();
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 10,
    'parentId.specified': false,
    'parcelId.equals': params?.id,
  });
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [loading, setLoading] = useState(false as boolean);

  const [cardCounts, setCardCounts] = useState({});
  const [countError, setCountError] = useState<string>('');



  useEffect(() => {
    getTickets();
    getTicketsCount();
    getingTicketCount(request);
    // setupFilters();
  }, [filtersValues, params?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const checkActiveCard = name => {
    const status = filtersValues['status.in']?.split(',') || [];
    switch (name) {
      case 'answered':
        return (
          status.includes('ATTENDEE_ANSWERED')

        );
      case 'open':
        return (
          status.includes('OPEN')
        );
      case 'closed':
        return status.includes('CLOSED');
      case 'pending':
        return status.includes('PENDING');
    }
  };

  const handleCardClose = () => {
    const newFilterValues = { ...filtersValues };
    delete newFilterValues['status.in'];
    setFiltersValues({
      ...removeEmptyValueObject(newFilterValues),
      page: 0,
      size: 10,
    });
  };

  const handleCardClick = name => {
    switch (name) {
      case 'answered':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['ATTENDEE_ANSWERED'],

          page: 0,
          size: 10,
        });
        break;
      case 'open':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['OPEN'],

          page: 0,
          size: 10,
        });
        break;
      case 'closed':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['CLOSED'],
          page: 0,
          size: 10,
        });
        break;
      case 'pending':
        setFiltersValues({
          ...removeEmptyValueObject(filtersValues),
          'status.in': ['PENDING'],
          page: 0,
          size: 10,
        });
        break;
    }
  };

  const getTickets = () => {
    const { page, size } = filtersValues;
    props.ticketDispatch({
      ...filtersValues,
      page,
      size,
    });
  };
  const getTicketsCount = () => {
    const { page, size } = filtersValues;
    props.ticketCountDispatch({
      ...filtersValues,
      page,
      size,
    });
  };

  const getingTicketCount = async (actions: any) => {
    try {
      setLoading(true);

      const { response: openCount } = await ordersRepository.getHelpicalTicketsCount({
        payload: actions.openCount
      });
      const { response: closeCount } = await ordersRepository.getHelpicalTicketsCount({
        payload: actions.closeCount
      });
      const { response: answeredCount } = await ordersRepository.getHelpicalTicketsCount({
        payload: actions.answeredCount
      });
      const { response: penddingCount } = await ordersRepository.getHelpicalTicketsCount({
        payload: actions.penddingCount
      });
      setCardCounts({
        openCount,
        closeCount,
        answeredCount,
        penddingCount
      });
    } catch (error) {
      setCountError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const request = {
    openCount: {
      'status.in': 'OPEN',
    },
    closeCount: {
      'status.in': 'CLOSED',
    },
    answeredCount: {
      'status.in': 'ATTENDEE_ANSWERED'
    },
    penddingCount: {
      'status.in': 'PENDING'
    }
  };


  const handleClose = () => {
    setOpenSize(false);
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };


  return (
    <React.Fragment>
      <Grid
        style={{
          zIndex: 3,
          backgroundColor: 'white',
          position: 'fixed',
          top: '0',
          right: '71px',
        }}
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Paper
          elevation={1}
          style={{
            width: '100%',
            borderRadius: '0',
          }}
        >
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              پشتیبانی
            </Typography>
          </div>
        </Paper>
      </Grid>
      <Grid container md={12} spacing={2} className={classes.mobile}>
        <Grid container spacing={2} item lg={12} xs={12}>
          <Grid item md={6} lg={3} xs={12}>
            <Card
              className={
                checkActiveCard('answered') ? classes.boxshadow : classes.cards
              }

            >
              <CardHeader
                action={
                  checkActiveCard('answered') && (
                    <IconButton
                      aria-label="close"
                      onClick={handleCardClose}
                      className={classes.iconHeader}
                      data-cy="cardCloseBtn"
                    >
                      <Icon
                        path={mdiClose}
                        size={1}
                        style={{
                          color: '#Ffffff',
                          backgroundColor: '#FFA65A',
                          borderRadius: '3px',
                        }}
                      />
                    </IconButton>
                  )
                }
              />
              <CardContent className={classes.cardContent} onClick={name => handleCardClick('answered')}
              >
                <Grid
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginRight: '10px',
                    textAlign: 'center',
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h6"
                    style={{
                      fontWeight: 600,
                      marginTop: '-20px',
                      fontSize: 28,
                      color: 'green',
                    }}
                  >
                    {cardCounts.answeredCount?.data}
                  </Typography>
                  <Typography
                    style={{
                      marginTop: '24px',
                      fontSize: 28,
                      marginBottom: '-20px',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    پاسخ داده شده
                  </Typography>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6} lg={3} xs={12}>
            <Card
              className={
                checkActiveCard('open') ? classes.boxshadow : classes.cards
              }
            >
              <CardHeader
                action={
                  checkActiveCard('open') && (
                    <IconButton
                      aria-label="close"
                      onClick={handleCardClose}
                      className={classes.iconHeader}
                      data-cy="cardCloseBtn"
                    >
                      <Icon
                        path={mdiClose}
                        size={1}
                        style={{
                          color: '#Ffffff',
                          backgroundColor: '#FFA65A',
                          borderRadius: '3px',
                        }}
                      />
                    </IconButton>
                  )
                }
              />
              <CardContent className={classes.cardContent} onClick={name => handleCardClick('open')}>

                <Grid
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    marginRight: '10px',
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h6"
                    style={{
                      fontWeight: 600,
                      marginTop: '-20px',
                      fontSize: 28,
                      color: 'orange',
                    }}
                  >
                    {cardCounts.openCount?.data}
                  </Typography>
                  <Typography
                    style={{
                      marginTop: '24px',
                      fontSize: 28,
                      marginBottom: '-20px',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    مشاهده شده
                  </Typography>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6} lg={3} xs={12}>
            <Card
              className={
                checkActiveCard('pending') ? classes.boxshadow : classes.cards
              }
            >
              <CardHeader
                action={
                  checkActiveCard('pending') && (
                    <IconButton
                      aria-label="close"
                      onClick={handleCardClose}
                      className={classes.iconHeader}
                      data-cy="cardCloseBtn"
                    >
                      <Icon
                        path={mdiClose}
                        size={1}
                        style={{
                          color: '#Ffffff',
                          backgroundColor: '#FFA65A',
                          borderRadius: '3px',
                        }}
                      />
                    </IconButton>
                  )
                }
              />

              <CardContent className={classes.cardContent} onClick={name => handleCardClick('pending')}>
                <Grid
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    marginRight: '10px',
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h6"
                    style={{
                      fontWeight: 600,
                      marginTop: '-20px',
                      fontSize: 28,
                      color: 'lightblue',
                    }}
                  >
                    {cardCounts.penddingCount?.data}
                  </Typography>
                  <Typography
                    style={{
                      marginTop: '24px',
                      fontSize: 28,
                      marginBottom: '-20px',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    در حال انجام
                  </Typography>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item md={6} lg={3} xs={12}>
            <Card
              className={
                checkActiveCard('closed') ? classes.boxshadow : classes.cards
              }
            >
              <CardHeader
                action={
                  checkActiveCard('closed') && (
                    <IconButton
                      aria-label="close"
                      onClick={handleCardClose}
                      className={classes.iconHeader}
                      data-cy="cardCloseBtn"
                    >
                      <Icon
                        path={mdiClose}
                        size={1}
                        style={{
                          color: '#Ffffff',
                          backgroundColor: '#FFA65A',
                          borderRadius: '3px',
                        }}
                      />
                    </IconButton>
                  )
                }
              />
              <CardContent className={classes.cardContent} onClick={name => handleCardClick('closed')}>
                <Grid
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    marginRight: '10px',
                  }}
                >
                  <Typography
                    variant="h6"
                    component="h6"
                    style={{
                      fontWeight: 600,
                      marginTop: '-20px',
                      fontSize: 28,
                      color: 'darkgray',
                    }}
                  >
                    {cardCounts.closeCount?.data}
                  </Typography>
                  <Typography
                    style={{
                      marginTop: '24px',
                      fontSize: 28,
                      marginBottom: '-20px',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    بسته شده
                  </Typography>
                </Grid>
              </CardContent>
            </Card>

            <Grid container item lg={12} md={12}>
              <Grid container item xs={12} md={12} lg={12}>

              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} item lg={12} xs={12}>
          <Grid md={12} item spacing={2}>
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <Grid>
                    <Typography>پیام‌های محموله شناسه {params.id}</Typography>
                  </Grid>
                }
              />
              <CardContent style={{ padding: '0' }}>
                <Grid container item xs={12} md={12} lg={12}>
                  {props.loading ? (
                    <div className={classes.loading}>
                      <CircularProgress />
                    </div>
                  ) : (
                    <>
                      {props.ticketsList?.length > 0 ? (
                        <List
                          data={props.ticketsList}
                        />


                      ) : (
                        <Typography variant="h3" component="div">
                          تیکت موجود نیست
                        </Typography>
                      )}
                    </>
                  )}
                </Grid>
                <Grid item xs={12} sm={12} style={{ padding: '20px 10px 0 10px' }}>
                  {props.ticketsList?.length > 0 && (
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                      <FormControl
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                          {' '}
                          تعداد نمایش در هر صفحه:
                        </div>
                        <Select
                          open={openSize}
                          onClose={handleClose}
                          onOpen={() => setOpenSize(true)}
                          value={filtersValues.size}
                          onChange={handleChangeSizePage}
                        >
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={20}>20</MenuItem>
                          <MenuItem value={50}>50</MenuItem>
                          <MenuItem value={100}>100</MenuItem>
                        </Select>
                      </FormControl>
                      <Pagination
                        count={Math.ceil(props.ticketCountList / filtersValues.size)}
                        color="secondary"
                        page={filtersValues.page + 1}
                        onChange={handleChangePage}
                      />
                    </div>

                  )}

                </Grid>
                <Grid
                  xs={12}
                  sm={6}
                  container
                  item
                  direction="row-reverse"
                  style={{ padding: '20px 10px 0 10px' }}
                >

                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ticketCountList: makeSelectTicketCountList(),
  ticketsList: makeSelectTicketsList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ticketDispatch: (payload: Payload) => dispatch(getTicketsAction(payload)),
    ticketCountDispatch: (payload: Payload) => dispatch(getTicketsCountAction(payload)),

  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(HelpdeskParcel);
